import type { SavedStudyBuilderDraftSummary } from '../hooks/study-builder/studyBuilderDrafts'

export function studySetupRowId(draftId: string): string {
  return `builder-draft:${draftId}`
}

export function studyDeletionReceipt(draft: SavedStudyBuilderDraftSummary) {
  return draft.state?.deletion ?? draft.deletion
}

export function canSelectStudyForDeletion(draft: SavedStudyBuilderDraftSummary): boolean {
  const receipt = studyDeletionReceipt(draft)
  return Boolean(draft.studyId && (draft.state?.canDelete || receipt?.status === 'failed'))
}
